import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ClientAgentCard } from '@apps/web/components/settings/client_agent_card';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/client-communication')({
    component: ClientCommunicationPage,
});

function ClientCommunicationPage() {
    const { organizationId, isLoading, gates } = useSettingsGates();
    // The client agent flag arrives with the organization; deciding before it
    // loads would bounce a cold deep link off the page.
    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.clientAgent) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Client communication"
            description="What Phoebe handles when it texts your clients."
        >
            <ClientAgentCard organizationId={organizationId} />
        </SettingsPageShell>
    );
}
